import React from 'react'

// eslint-disable-next-line import/prefer-default-export
export const ShareButton = () => {
  const text = 'Celebrate Twitter’s 15th anniversary by seeing my top tweets of all time. What are yours? Twitterverse by @spacecadet'

  const url = window.location
  return (
    <div className="share">
      <p>Share</p>
      <a href={`https://twitter.com/intent/tweet?text=${text}&url=${url}`} className="twitter-share-button">
        <span>&#43;</span>
      </a>
    </div>
  )
}
